
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#chat-clip0)","fill":"#fff"}},[_c('path',{attrs:{"d":"M0 12.374c0 5.306 3.515 9.624 7.837 9.624 2.188 0 4.24-1.1 5.717-3.042.96.617 2.017 1.472 2.277 2.52a.688.688 0 001.354-.136c0-.017.003-.078.003-.175 0-.714-.114-3.456-1.728-6.568.142-.71.213-1.456.213-2.223 0-5.305-3.515-9.624-7.836-9.624C3.515 2.75 0 7.07 0 12.374zm14.298 0c0 .756-.078 1.486-.233 2.172a.683.683 0 00.066.479 14.398 14.398 0 011.366 3.653c-.566-.486-1.199-.891-1.783-1.236a.687.687 0 00-.924.216c-1.235 1.885-3.04 2.965-4.953 2.965-3.564 0-6.462-3.7-6.462-8.249 0-4.55 2.898-8.249 6.462-8.249 3.562 0 6.461 3.7 6.461 8.25z"}}),_c('path',{attrs:{"d":"M20.63.52c-.199.787-.832 1.547-1.887 2.264C17.368 1.007 15.475.002 13.46.002c-.956 0-1.898.229-2.797.678a.69.69 0 00.616 1.23 4.845 4.845 0 012.18-.533c1.744 0 3.394.99 4.526 2.715.201.308.61.402.926.214a9.767 9.767 0 001.482-1.056 11.901 11.901 0 01-1.173 3.218.693.693 0 00-.066.474c.608 2.764-.111 5.74-1.756 7.605a.688.688 0 101.031.91c1.879-2.133 2.726-5.442 2.12-8.561C21.834 4.394 22 2.146 22 1.154c0-.314-.017-.501-.02-.532a.686.686 0 00-1.35-.101z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"chat-clip0"}},[_c('path',{attrs:{"d":"M2 22a2 2 0 01-2-2V2a2 2 0 012-2h20v22H2z","fill":"#fff"}})])])])
          )
        }
      }
    